<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: 'App',
    data() {
        return {
           
        }
    },
}
</script>

<style>
@font-face {
  font-family: 'SourceHanSansCN-Bold';
  src: url('../src/assets/font/SourceHanSansCN-Bold.otf') format('opentype');
}
@font-face {
  font-family: 'SourceHanSansCN-Medium';
  src: url('../src/assets/font/SourceHanSansCN-Medium.otf') format('opentype');
}
#app {
  font-size: 0.48rem; 
  height: 100%;
}

</style>
